import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'CODE_ACCES',
  title: 'Come posso generare un codice di accesso per le mie gare d’appalto?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Clienti».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CODE_ACCES/IT_CODE_ACCES_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sui 3 punti in alto a destra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CODE_ACCES/IT_CODE_ACCES_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Fare clic su «Generare un codice di accesso»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CODE_ACCES/IT_CODE_ACCES_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Inserisci le informazioni necessarie'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CODE_ACCES/IT_CODE_ACCES_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Confermare!'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CODE_ACCES/IT_CODE_ACCES_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Non vi resta che scaricare e trasmettere il documento al vostro cliente, o trascinarlo nella cartella di gara d\'appalto.'
  }]
};
